import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Box, Typography, Tooltip, Drawer, Stack, Button } from "@mui/material";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions';

const datelist = {
  fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
  toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
  dateIndex: 1,
}

function StoreSubLocLowStock(props) {
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [purReturnData, setpurReturnData] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [filterData, setfilterData] = useState(datelist);

  useEffect(() => {
    getStorePurchase()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getStorePurchase = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(`${Serviceurls.STORE_SUBLOC_LOW_STOCK}?from_date=${filterData?.fromDate || ""}&to_date=${filterData?.toDate || ""}`)
        .then((response) => {
          if (response.data.status === 'success') {
            setpurReturnData(response.data.data || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.message) {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const FilterDate = (from, to, index) => {
    setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
  }

  const renderFilterScreen = () => {
    return (
      <Box className='eMed_rts_filter_container' >
        <Box className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>Filter</Typography>
          <Tooltip>
            <Button onClick={() => { setFilterOpen(false) }}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
            </Button>
          </Tooltip>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={filterData.fromDate}
              ToDate={filterData.toDate}
              DateIndex={filterData.dateIndex}
              SelectedDates={FilterDate.bind(this)}
              HideAllMenu={true} />
          </Box>
        </Box>
        <Box>
          <Stack spacing={2} direction="row" justifyContent={'center'}>
            <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => { setfilterData(datelist) }}>Clear</Button>
            <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => { getStorePurchase() }}>Search</Button>
          </Stack>
        </Box>
      </Box>
    )
  }

  const closeFilter = () => {
    setFilterOpen(false);
  }

  const tableView = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box>
            <CommonGridToolBarWithFilterText />
          </Box>
        )
      }
      purReturnData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'product_code', headerName: 'Product Code', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.product_code || "-"}</Box>)
        },
        {
          field: 'product_name', headerName: 'Product Name', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.product_name || '-'}</Box>)
        },
        {
          field: 'category_name', headerName: 'Category', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.category_name || "-"}</Box>)

        },
        {
          field: 'department_name', headerName: 'Department', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.department_name || "-"}</Box>)

        },
        {
          field: 'total_quantity', headerName: 'Available Qty', flex: 0.07, type: "number",
          renderCell: (params) => (<Box component={'div'}>{(params?.row?.total_quantity || 0)}</Box>)

        },
        {
          field: 'reorder_threshold', headerName: 'ROL', flex: 0.07, type: "number",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.reorder_threshold ? (params?.row?.reorder_threshold) : 0}</Box>)

        }
      ];
      return (
        <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={purReturnData}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  const msgClose = () => {
    seterrorMsg(false)
    seterrorMsgText("")
    setsuccessMsg(false)
    setsuccessMsgText("")
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
        <Box>
          <IconButton onClick={() => { setFilterOpen(true) }}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
          </IconButton>
        </Box>
      </Box>
      <Box>
        {tableView()}
      </Box>
      <Drawer
        anchor={'right'}
        open={filterOpen}
        ModalProps={{ onBackdropClick: closeFilter }}
      >
        {renderFilterScreen()}
      </Drawer>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  );
}

export default StoreSubLocLowStock